import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BenefitCustomerBlockData from '../../../Models/Content/BenefitCustomerBlockData';
import BenefitPage from './BenefitPage';
import './benefitCustomerBlock.scss';

export default class BenefitCustomerBlock extends EpiComponent<BenefitCustomerBlockData> {

    public render(): ReactNode | ReactNodeArray | null {
        return (
          <BenefitPage iContent={this.props.data} context={this.getContext()} />
        );
      }
}
